import { useState, useEffect } from 'react'
import { attendancesService } from '../services/attendances'
import { useAuth } from './useAuth'

const POLL_INTERVAL_MS = 60_000

// Badge de "Solicitações" no menu: quantos pedidos esperam uma ação da
// gestão — chegaram sem setor, ou um setor devolveu pra confirmar. Só gestão
// vê essa tela (o backend devolve 403 pro resto).
export function useSolicitationsInboxCount(): number {
  const [count, setCount] = useState(0)
  const { user } = useAuth()
  const role = user?.profile?.role
  const isEligible = (role === 'manager' || role === 'coordinator') && !user?.is_staff

  useEffect(() => {
    if (!isEligible) return

    let cancelled = false
    const fetchCount = async () => {
      try {
        const { counts } = await attendancesService.listSchoolSolicitations('sem_setor')
        if (!cancelled) setCount(counts.sem_setor + (counts.confirmar ?? 0))
      } catch {
        // silencioso — badge não é crítico
      }
    }

    fetchCount()
    const interval = setInterval(fetchCount, POLL_INTERVAL_MS)
    return () => {
      cancelled = true
      clearInterval(interval)
    }
  }, [isEligible])

  return count
}
